import React from 'react';
import { skillCategories } from '../../data/portfolio';

const Skills = () => (
  <section className="section skills-section" id="skills" aria-labelledby="skills-title">
    <div className="shell">
      <div className="section-heading section-heading-row"><div><span className="section-number">06 / TECHNICAL SKILLS</span><h2 id="skills-title">Tools for the full system.</h2></div><p>From model behavior and retrieval to reliable APIs, infrastructure, and evaluation.</p></div>
      <div className="skills-grid">{skillCategories.map((category, index) => <div className="skill-group" key={category.title}><div className="skill-group-heading"><span>{String(index + 1).padStart(2, '0')}</span><h3>{category.title}</h3></div><div className="skill-items">{category.skills.map((skill) => <span key={skill}>{skill}</span>)}</div></div>)}</div>
    </div>
  </section>
);

export default Skills;
